import { render, staticRenderFns } from "./TaskPriority.vue?vue&type=template&id=01d18a2c&scoped=true&"
import script from "./TaskPriority.vue?vue&type=script&lang=js&"
export * from "./TaskPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d18a2c",
  null
  
)

export default component.exports